import {useReducer} from 'react';
import {ChromePicker, type ColorResult} from 'react-color';
import {classNames} from 'utils';

interface IColorPickerProps {
  alignment?: 'left' | 'right';
  color: string;
  onPicked: (color: ColorResult) => void;
}

const ColorPicker = ({color, onPicked, alignment = 'left'}: IColorPickerProps) => {
  const [show, toggleShow] = useReducer(s => !s, false);
  return (
    <div className="relative">
      <div className="flex items-center">
        <button type="button" className="inline-block p-0.5 bg-white rounded-xs border border-slate-400 cursor-pointer" onClick={toggleShow}>
          <div className="w-10 h-4 rounded-xs" style={{background: color}} />
        </button>
      </div>
      {show ? (
        <div className={classNames('absolute top-8', alignment === 'left' ? 'left-0' : 'right-0')}>
          <div className="fixed inset-0" onClick={toggleShow} />
          <ChromePicker color={color} onChange={onPicked} />
        </div>
      ) : null}
    </div>
  );
};

export default ColorPicker;
